import { render, staticRenderFns } from "./PushNotificationsTab.vue?vue&type=template&id=360bfa6e&"
import script from "./PushNotificationsTab.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports